
import React from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import IconButton from "@material-ui/core/IconButton";
import Button from "../../CustomButtons/Button.jsx";
import CustomInput from "../../CustomInput/CustomInput.jsx";
import CustomFileInput from "../../CustomFileInput/CustomFileInput";
import axios from "axios";
import Api from "../../../../assets/js/utils/Api";
import LoaderComponent from '../../Loader';
import PhotoErrorModal from "../../Modals/PhotoErrorModal.js";
// import locationIcon from "../../../../assets/img/location.svg";
// import photoIcon from "../../../../assets/img/photo.svg";
// import beddingAreaIcon from "../../../../assets/img/bedding-area.svg";

import toolsStyle from "../../../../assets/jss/toolsStyle.jsx";

class Waypoint extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            formData: this.props.formData,
            colors: this.getColors(),
            icons: this.getIcons(),
            design: this.props.design,
            uploading: false,
            showError: false,
            success: false,
            photos: [],
            photoErrorModal: false
        }
    }
    componentWillReceiveProps(props){
        this.setState({
            formData: props.formData,
            design: props.design
        });
    }
    getColors(){
        let colors = [
            {
                colorName: 'orange',
                color: 'rgba(255, 51, 0, 1.0)'
            },
            {
                colorName: 'blue',
                color: 'rgba(8, 122, 255, 1.0)'
            },
            {
                colorName: 'cyan',
                color: 'rgba(0, 255, 255, 1.0)',
            },
            {
                colorName: 'black',
                color: 'rgba(0, 0, 0, 1.0)',
            },
            {
                colorName: 'white',
                color: 'rgba(255, 255, 255, 1.0)',
            },
            {
                colorName: 'purple',
                color: 'rgba(128, 0, 128, 1.0)',
            },
            {
                colorName: 'yellow',
                color: 'rgba(255, 255, 0, 1.0)',
            },
            {
                colorName: 'red',
                color: 'rgba(255, 0, 0, 1.0)',
            },
            {
                colorName: 'brown',
                color: 'rgba(139, 69, 19, 1.0)',
            }
        ];               

        return colors;
    }
    getIcons(){ 
        let icons = [
            '4x4',
            'location',
            'photo',
            'bedding-area'
        ];

        return icons;
    }
    handleSubmit(){
        this.props.formSubmit('waypoint')
    }
    handleChange(e, name){
        let formData = {
            ...this.state.formData,
            [name]: e.target.value
        };

        this.setState({
            formData: formData
        });

        this.props.updateFormData(formData, 'waypoint');
    }
    handleChangeColor(color, colorName){
        let design = {
            ...this.state.design,
            color : color,
            colorName: colorName,
        };

        this.setState({
            design: design
        });

        this.props.updateDesign(design, 'waypoint');
    }
    handleChangeIcon(icon){
        let design = {
            ...this.state.design,
            icon : icon,
        };

        this.setState({
            design: design
        });

        this.props.updateDesign(design, 'waypoint');
    }
    getIcon(icon){
        switch(icon) {
            case '4x4': 
                return (
                    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd" d="M2.443 11.188h-.348a.097.097 0 0 0-.069.029.094.094 0 0 0-.026.07v1.388a.118.118 0 0 0 .12.114h.599a.12.12 0 0 0 .124-.119v-.947h.395l.3 1.847-.058.067-.204-.17a3.022 3.022 0 0 0-.348.534l.238.114a2.63 2.63 0 0 0-.114.265l-.248-.085c-.07.2-.119.406-.142.616l.261.033c-.014.095-.024.19-.028.284h-.252c0 .214.023.427.071.635l.252-.061c.024.093.052.185.086.274l-.248.09c.071.201.167.392.286.57l.214-.138c.056.079.117.155.181.227l-.205.17c.142.163.302.31.476.436l.162-.208c.075.06.155.113.238.161l-.133.227c.182.11.377.198.58.261l.081-.251c.031.01.061.02.091.032.063.024.126.049.19.049l-.047.25c.174.033.35.05.528.048h.105v-.26c.097-.005.194-.015.29-.029l.038.256c.212-.03.42-.085.619-.166l-.1-.237c.09-.04.177-.084.262-.133l.123.233c.19-.1.366-.222.524-.365l-.176-.2a1.63 1.63 0 0 0 .204-.203l.2.175c.14-.159.263-.332.367-.516l-.233-.128c.047-.083.09-.168.128-.256l.238.095c.08-.198.138-.405.171-.616l-.261-.038a1.92 1.92 0 0 0 .028-.289h.262a2.614 2.614 0 0 0-.048-.578l.652-.597s.1.162.167.28a.29.29 0 0 0 .3.17l5.84-.037a.277.277 0 0 0 .27-.214l.1-.402c.16-.677.37-1.34.63-1.985a.61.61 0 0 1 .256-.346c.013.065.056.253.112.493.07.303.16.688.23 1.018a2.91 2.91 0 0 0-.313.374l.276.19a1.738 1.738 0 0 0-.138.242l-.305-.162c-.101.186-.18.383-.233.588l.328.09-.021.074c-.02.065-.04.13-.04.196l-.338-.052c-.021.149-.032.3-.034.45v.175h.343a.936.936 0 0 1 .028.275l-.333.057a3 3 0 0 0 .176.606l.31-.128c.04.085.084.167.133.247l-.305.165c.093.182.203.355.329.517l.257-.228.195.195-.229.255c.16.138.332.26.514.365l.172-.298c.078.049.16.093.243.132l-.129.308c.196.082.4.142.61.18l.056-.331c.09.028.186.028.281.028v.341h.195c.145.001.29-.01.433-.033l-.052-.336c.093-.014.185-.033.276-.057l.086.331a2.86 2.86 0 0 0 .57-.227l-.156-.303.05-.026c.065-.034.132-.069.193-.107l.185.275c.175-.118.334-.256.476-.412l-.247-.232c.065-.067.125-.138.18-.213l.272.203c.143-.17.264-.358.361-.559l-.309-.137c.037-.087.069-.175.095-.265l.329.108c.06-.192.102-.39.123-.592l-.342-.028v-.28h.338a3.051 3.051 0 0 0-.081-.625l-.333.08a1.71 1.71 0 0 0-.081-.265l.319-.118a2.977 2.977 0 0 0-.281-.564l-.286.185a1.507 1.507 0 0 0-.171-.218l.271-.218a2.85 2.85 0 0 0-.452-.44l-.195.241.395-1.525.424.042v.92a.137.137 0 0 0 .133.132h.57A.134.134 0 0 0 22 12.58v-.772a.132.132 0 0 0-.088-.14.138.138 0 0 0-.06-.007h-.204a21.096 21.096 0 0 1-.017-.212c-.013-.156-.025-.32-.045-.475a.285.285 0 0 0-.119-.151 1.566 1.566 0 0 0-.324-.157.338.338 0 0 1-.204-.274 7.613 7.613 0 0 0-.048-.255 7.047 7.047 0 0 1-.062-.347.165.165 0 0 0-.176-.156c-.307-.032-1.344-.15-2.489-.28a311.963 311.963 0 0 0-3.788-.422l-.91-2.743A.275.275 0 0 0 13.21 6h-5.5a.272.272 0 0 0-.257.26v1.237l-3.122 2.09h-1.59a.205.205 0 0 0-.204.203v1.303a.084.084 0 0 1-.025.07.086.086 0 0 1-.07.024Zm16.99 4.954a1.213 1.213 0 0 1-.68.195h.01a1.213 1.213 0 0 1-1.112-.742 1.205 1.205 0 0 1 .658-1.583 1.219 1.219 0 0 1 1.326.268 1.206 1.206 0 0 1-.202 1.862Zm-.66.195h-.01.01Zm-1.217-3.799.036-.02.138.309c.061-.027.125-.047.188-.067l.074-.023-.1-.327c.2-.065.408-.106.619-.123l.028.34h.214v-.33c.211 0 .422.022.628.065l-.076.332a.69.69 0 0 1 .105.028l.13-.447c.08-.268.16-.543.184-.652l-2.38-.061c.006.035.05.237.106.49l.106.486Zm-13.133.1-.167-.948 2.327.019-.28 1.16a2.672 2.672 0 0 0-.276-.09l.057-.25a2.874 2.874 0 0 0-.633-.072h-.214v.265a2.02 2.02 0 0 0-.29.029l-.048-.251a2.678 2.678 0 0 0-.476.137Zm5.136.172a.185.185 0 0 1-.068-.097l-.875-3.127h-.471V6.824a.198.198 0 0 1 .195-.203l4.34-.024a.277.277 0 0 1 .267.19l.814 2.496-.138 3.425a.147.147 0 0 1-.143.138H9.672a.186.186 0 0 1-.113-.036Zm-2.143.879.21-.161.033.005a2.85 2.85 0 0 0-.424-.441l.229-1.194.9 1.582-.477.474-.08-.16-.229.132a2.606 2.606 0 0 0-.162-.237Zm.005-5.34v1.223l-1.842.01L7.421 8.35Zm-1.334 7.865c-.2.133-.434.204-.674.204l.033.004a1.22 1.22 0 0 1-1.153-.74 1.204 1.204 0 0 1 .655-1.588 1.218 1.218 0 0 1 1.323.261 1.206 1.206 0 0 1-.184 1.86Zm4.19-6.789c-.062-.204-.158-.374-.39-.402a.693.693 0 0 0-.643.26.444.444 0 0 0-.043.44l.443 1.517c.07.25.142.483.218.724a.706.706 0 0 0 .695.522h1.952a.477.477 0 0 0 .447-.474v-.948a.473.473 0 0 0-.5-.435H10.62l-.007-.025a48.605 48.605 0 0 1-.335-1.179Z" fill="inherit" />
                    </svg>
                );
            case 'location':
                return (
                    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd" d="M22 18.1075L18.1076 22L12.0003 15.8925L5.89235 22L2 18.1075L8.10736 12L2 5.8919L5.89235 2L12.0003 8.10697L18.1076 2L22 5.8919L15.8926 12L22 18.1075Z" fill="inherit"/>
                    </svg>
                );
            case 'photo':
                return (
                    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd" d="M17.833 10.2347C17.833 10.5944 18.113 10.8863 18.458 10.8863C18.803 10.8863 19.083 10.5944 19.083 10.2347C19.083 9.87505 18.803 9.58314 18.458 9.58314C18.113 9.58314 17.833 9.87505 17.833 10.2347ZM7.39062 12.434C7.39062 15.0833 9.45854 17.2391 11.9998 17.2391C14.5415 17.2391 16.6094 15.0833 16.6094 12.434C16.6094 9.78426 14.5415 7.62844 11.9998 7.62844C9.45854 7.62844 7.39062 9.78426 7.39062 12.434ZM18.1417 6.89508H20.125C21.1608 6.89508 22 7.77036 22 8.85023V18.1134C22 18.2828 21.8687 18.42 21.7063 18.42H2.29417C2.13167 18.42 2 18.2828 2 18.1134V8.85023C2 7.77036 2.83958 6.89508 3.875 6.89508H5.97625C6.265 6.89508 6.51583 6.68919 6.58333 6.39642L7.02083 4.49774C7.22542 3.61595 7.975 3 8.84458 3H15.1946C16.0304 3 16.7725 3.58511 16.9992 4.4239L17.5396 6.42074C17.6163 6.70048 17.8633 6.89508 18.1417 6.89508ZM12.0002 8.93157C10.1477 8.93157 8.64062 10.5032 8.64062 12.434C8.64062 14.3644 10.1477 15.9359 12.0002 15.9359C13.8527 15.9359 15.3598 14.3644 15.3598 12.434C15.3598 10.5032 13.8527 8.93157 12.0002 8.93157ZM2.47693 19.4931C2.25734 19.4931 2.11276 19.7364 2.21318 19.9401C2.52443 20.5686 3.15109 21 3.87526 21H20.1253C20.8494 21 21.4761 20.5686 21.7873 19.9401C21.8882 19.7364 21.7432 19.4931 21.5236 19.4931H2.47693Z" fill="inherit"/>
                    </svg>
                );
            case 'bedding-area':
                return (
                    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd" d="M15.9713 16.8566H8.30202C7.70137 16.6916 7.49753 15.9712 7.38319 15.4604C7.26753 14.9583 7.14223 14.4581 7.00729 13.9597C6.74223 12.9702 6.43379 11.9863 6.0868 11.0298C5.73732 10.0772 5.32154 9.15811 4.84343 8.28127C4.38132 7.3851 3.76098 6.60825 3.02174 6C3.69816 6.6712 4.24328 7.49713 4.62174 8.42419C5.02226 9.33222 5.35438 10.2775 5.61451 11.2497C5.87802 12.2185 6.09839 13.2019 6.27476 14.1961C6.36632 14.6908 6.45307 15.202 6.52054 15.6913C6.57345 16.0749 6.62636 16.489 6.66068 16.8566H6.59268C6.52344 16.2048 6.38616 15.5644 6.18359 14.9492C5.98582 14.2906 5.74248 13.6509 5.45588 13.0362C5.17737 12.4204 4.83779 11.8431 4.44383 11.3157C4.06327 10.7813 3.56399 10.3731 2.99805 10.1338C3.516 10.4478 3.95044 10.9149 4.25588 11.4861C4.56553 12.0457 4.81932 12.6431 5.0125 13.2671C5.2158 13.886 5.37692 14.5219 5.49443 15.1691C5.5794 15.6197 5.62903 16.0777 5.64288 16.5377C5.41105 15.622 5.09626 14.7359 4.70341 13.894C4.49119 13.4252 4.25128 12.9734 3.98534 12.5417C3.74234 12.0957 3.41252 11.7195 3.02148 11.4423C3.35581 11.7818 3.61646 12.2052 3.78293 12.6791C3.96988 13.1434 4.13085 13.6208 4.26486 14.1084C4.34169 14.3935 4.41 14.6813 4.46972 14.9714C4.3408 14.8003 4.20166 14.6386 4.05301 14.4874C3.75787 14.1813 3.43473 13.9122 3.08916 13.6849C2.75886 13.4458 2.38746 13.2902 2 13.2286C2.3581 13.3758 2.68374 13.6103 2.95422 13.9157C3.23103 14.198 3.47698 14.5173 3.68675 14.8667C3.88133 15.2028 4.04294 15.5623 4.16867 15.9386C4.18597 15.9924 4.20234 16.0464 4.21777 16.1008C4.04898 15.8572 3.85479 15.6364 3.6388 15.4437C3.43572 15.2556 3.21415 15.0951 2.97856 14.9654C2.75408 14.8218 2.49809 14.7551 2.24121 14.773C2.46383 14.8518 2.66255 15.0004 2.8147 15.2018C2.98034 15.3906 3.12592 15.6009 3.24844 15.8285C3.4837 16.2294 3.63263 16.6878 3.68335 17.1665L3.75361 18H20.2163L20.2966 17.2671L20.3036 17.269C20.3455 16.7786 20.4947 16.308 20.7373 15.9003C20.861 15.6719 21.0064 15.4599 21.171 15.2681C21.3298 15.0651 21.5351 14.9166 21.7638 14.8394C21.5094 14.8347 21.2583 14.9068 21.0361 15.0482C20.8008 15.1816 20.578 15.3418 20.371 15.5265C20.1523 15.7138 19.9551 15.9301 19.7834 16.17C19.7958 16.1294 19.8087 16.089 19.8221 16.0488C19.9432 15.6614 20.105 15.2923 20.3041 14.9494C20.5166 14.604 20.7623 14.2869 21.0366 14.0039C21.3073 13.6934 21.6371 13.4582 22.0004 13.3168C21.6152 13.3748 21.2463 13.5308 20.9209 13.773C20.5744 13.9966 20.2511 14.264 19.9571 14.5701C19.7977 14.7316 19.6492 14.905 19.5123 15.0891C19.5737 14.7906 19.6446 14.4947 19.7249 14.2017C19.8567 13.715 20.0177 13.2393 20.2068 12.7779C20.3706 12.3023 20.6316 11.8783 20.9683 11.5411C20.5772 11.8183 20.2474 12.1945 20.0044 12.6405C19.7383 13.074 19.4984 13.5276 19.2863 13.9983C19.0447 14.515 18.8328 15.0485 18.6516 15.5954C18.6685 15.484 18.6875 15.373 18.7088 15.2625C18.8263 14.6153 18.9875 13.9794 19.1908 13.3605C19.3823 12.7367 19.6345 12.1393 19.9426 11.5794C20.2511 11.0097 20.6847 10.5417 21.2004 10.2217C20.6362 10.4648 20.1377 10.8722 19.7546 11.4035C19.3606 11.931 19.0211 12.5083 18.7426 13.1241C18.4553 13.7391 18.2103 14.3787 18.01 15.0371C17.9189 15.3196 17.8411 15.6072 17.7768 15.8985L17.7924 15.7903C17.8647 15.2956 17.9466 14.7954 18.0382 14.3006C18.2213 13.3057 18.4382 12.3217 18.7033 11.3487C18.9634 10.3783 19.2955 9.43491 19.696 8.52876C20.0732 7.59922 20.6184 6.7712 21.296 6.09908C20.5581 6.70962 19.9394 7.48832 19.4792 8.38584C18.9965 9.26062 18.579 10.18 18.231 11.1344C17.8808 12.0945 17.5739 13.073 17.3105 14.0698C17.2205 14.3996 17.1391 14.7343 17.0577 15.069C17.017 15.2363 16.9763 15.4037 16.9346 15.5705C16.8148 16.0488 16.4923 16.7482 15.9713 16.8566Z" fill="inherit"/>
                    </svg>
                );
            default:
                return <></>;
        }
    }
    getIconLi(icon, key){
        return (
            <li className={"icon "+(this.state.design.icon === icon ? 'selected' : '')} key={key} onClick={() => this.handleChangeIcon(icon)}>
                { this.getIcon(icon) }
            </li>
        )
    }
    getColorLi(colorItem, key){
        let color = colorItem.color;
        let colorName = colorItem.colorName;

        return (
            <li className={"color "+(this.state.design.color === color ? 'selected' : '')} key={key} onClick={() => this.handleChangeColor(color, colorName)} style={{backgroundColor: color}}></li>
        )
    }
    handleFileChange(e, name, photoModal = false){
        let photo = e.target.files[0];
        
        let photoErrorModal = true;
        if(photo.type === "image/jpeg" || photo.type === "image/png"){
            photoErrorModal = false;
        }

        if(photoErrorModal){
            this.setState({
                photoErrorModal: true
            })
            return true;
        }

        var requestData = new FormData();
        requestData.append('photo', photo);

        const source = axios.CancelToken.source();
        this.setState({
            [name]: photo,
            uploading: true,
            cancelToken: source,
            showError: false,
        });

        const that = this;
        Api.uploadWaypointPhoto(requestData, source).then(data => {
            let photosArray = this.state.photos
            photosArray.push(data.photo);

            let formData = {
                ...this.state.formData,
                attachments: photosArray
            };
            if(photoModal === true){
                formData.photoModal = true;
            }

            that.setState({
                success: true,
                uploading: false,
                photos: photosArray,
                formData: formData
            });            

            this.props.updateFormData(formData, 'waypoint');
        }).catch(err => {
            if(typeof(err) === "object" && err.hasOwnProperty("message") && err.message !== 'Request Cancelled'){
                this.setState({
                    uploading: false,
                    showError: true,
                    errorMessage: err.message
                });
            }
        });
    }
    getPhoto(photo, key){
        return (
            <img className="image" src={photo.sizes.default} alt="waypoint-img" key={key}/>
        )
    }
    closePhotoErrorModal(){
        this.setState({
            photoErrorModal: false
        })
    }
    render() {
        const { classes, section } = this.props;
        const { title, notes } = this.state.formData;
        const { uploading, photos, photoErrorModal } = this.state;
        
        if(section === 'photo'){
            return (
                <div className={classes.popoverContent+" photo-popover-content"}>
                    <div className="header">
                        <div className="icon">
                            <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" clipRule="evenodd" d="M17.833 10.2347C17.833 10.5944 18.113 10.8863 18.458 10.8863C18.803 10.8863 19.083 10.5944 19.083 10.2347C19.083 9.87505 18.803 9.58314 18.458 9.58314C18.113 9.58314 17.833 9.87505 17.833 10.2347ZM7.39062 12.434C7.39062 15.0833 9.45854 17.2391 11.9998 17.2391C14.5415 17.2391 16.6094 15.0833 16.6094 12.434C16.6094 9.78426 14.5415 7.62844 11.9998 7.62844C9.45854 7.62844 7.39062 9.78426 7.39062 12.434ZM18.1417 6.89508H20.125C21.1608 6.89508 22 7.77036 22 8.85023V18.1134C22 18.2828 21.8687 18.42 21.7063 18.42H2.29417C2.13167 18.42 2 18.2828 2 18.1134V8.85023C2 7.77036 2.83958 6.89508 3.875 6.89508H5.97625C6.265 6.89508 6.51583 6.68919 6.58333 6.39642L7.02083 4.49774C7.22542 3.61595 7.975 3 8.84458 3H15.1946C16.0304 3 16.7725 3.58511 16.9992 4.4239L17.5396 6.42074C17.6163 6.70048 17.8633 6.89508 18.1417 6.89508ZM12.0002 8.93157C10.1477 8.93157 8.64062 10.5032 8.64062 12.434C8.64062 14.3644 10.1477 15.9359 12.0002 15.9359C13.8527 15.9359 15.3598 14.3644 15.3598 12.434C15.3598 10.5032 13.8527 8.93157 12.0002 8.93157ZM2.47693 19.4931C2.25734 19.4931 2.11276 19.7364 2.21318 19.9401C2.52443 20.5686 3.15109 21 3.87526 21H20.1253C20.8494 21 21.4761 20.5686 21.7873 19.9401C21.8882 19.7364 21.7432 19.4931 21.5236 19.4931H2.47693Z" fill="inherit"/>
                            </svg>
                        </div>
                        <div className="popover-title">
                            <h4 className="with-icon">Add a Photo</h4>
                        </div>
                        <IconButton title="Close card" onClick={this.props.onClose}>
                            <span className="x-icon">
                                <svg width="25" height="30" viewBox="0 0 30 30" fill="#333" xmlns="http://www.w3.org/2000/svg">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M21.7677 7.62548C21.3772 7.23496 20.744 7.23496 20.3535 7.62548L14.9997 12.9792L9.64623 7.62577C9.25571 7.23524 8.62254 7.23524 8.23202 7.62577L7.62593 8.23186C7.23541 8.62238 7.23541 9.25555 7.62593 9.64607L12.9794 14.9996L7.62556 20.3534C7.23503 20.7439 7.23503 21.3771 7.62556 21.7676L8.23165 22.3737C8.62217 22.7642 9.25534 22.7642 9.64586 22.3737L14.9997 17.0199L20.3539 22.374C20.7444 22.7645 21.3775 22.7645 21.7681 22.374L22.3742 21.7679C22.7647 21.3774 22.7647 20.7442 22.3742 20.3537L17.02 14.9996L22.3738 9.64579C22.7643 9.25526 22.7643 8.6221 22.3738 8.23157L21.7677 7.62548Z" fill="#333"></path>
                                </svg>
                            </span>
                        </IconButton>
                    </div>
                    <div className="popover-content">
                        <div className="edit-markup-content">
                            <form>
                                <div className="photo-container">
                                    <div className="photo-upload-box">
                                        {
                                            uploading === true ?
                                                <LoaderComponent align="center" color="info" />
                                            :
                                                <>
                                                    <div className="drag-drop-label">Select .JPG or .PNG file</div>
                                                    <div className="add-photo-button">
                                                        <CustomFileInput
                                                            id="add-photo-btn"
                                                            onChange={(e) => this.handleFileChange(e,'photo', true)}
                                                            endButton={{
                                                                buttonProps: {
                                                                    fileButton: true,
                                                                    link: true
                                                                },
                                                                text: "Click to Select"
                                                            }}
                                                            inputProps={{
                                                                value: "",
                                                                placeholder: "Photo",
                                                                accept: ".jpeg, .jpg, .png"
                                                            }}
                                                            color="info"
                                                            formControlProps={{
                                                                fullWidth: true,
                                                            }}
                                                        />
                                                    </div>
                                                </>
                                        }
                                    </div>
                                </div>
                                <div className="edit-actions">
                                    <Button type="button" onClick={this.props.onClose} color="github" fullWidth>Cancel</Button>
                                </div>
                            </form>
                        </div>
                    </div>
                    {
                        photoErrorModal ?
                            <PhotoErrorModal 
                                open={photoErrorModal} 
                                onClose={() => this.closePhotoErrorModal()} 
                                title="Your photo must be a .JPG or .PNG"
                                buttonText="Ok"
                            />
                        :
                            <></>
                    }
                </div>
            )
        }
        return (
            <div className={classes.popoverContent}>
                <header>
                    <div className="close">
                        <IconButton title="Close card" onClick={this.props.onClose}>
                            <span className="x-icon">
                                <svg width="25" height="30" viewBox="0 0 30 30" fill="#333" xmlns="http://www.w3.org/2000/svg">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M21.7677 7.62548C21.3772 7.23496 20.744 7.23496 20.3535 7.62548L14.9997 12.9792L9.64623 7.62577C9.25571 7.23524 8.62254 7.23524 8.23202 7.62577L7.62593 8.23186C7.23541 8.62238 7.23541 9.25555 7.62593 9.64607L12.9794 14.9996L7.62556 20.3534C7.23503 20.7439 7.23503 21.3771 7.62556 21.7676L8.23165 22.3737C8.62217 22.7642 9.25534 22.7642 9.64586 22.3737L14.9997 17.0199L20.3539 22.374C20.7444 22.7645 21.3775 22.7645 21.7681 22.374L22.3742 21.7679C22.7647 21.3774 22.7647 20.7442 22.3742 20.3537L17.02 14.9996L22.3738 9.64579C22.7643 9.25526 22.7643 8.6221 22.3738 8.23157L21.7677 7.62548Z" fill="#333"></path>
                                </svg>
                            </span>
                        </IconButton>
                    </div>
                </header>
                <div className="popover-content">
                    <div className="edit-markup-content">
                        <form>
                            <div className="markup-scroll-content">
                                <CustomInput
                                    id="input-titleText"
                                    labelText="Waypoint Name"
                                    inputProps={{
                                        onChange: (e) => this.handleChange(e,'title'),
                                        value: title,
                                        name: "title",
                                        type: "text",
                                    }}
                                    color="info"
                                    formControlProps={{
                                        fullWidth: true,
                                        className: classes.customFormControlClasses
                                    }}
                                />
                                <div className="edit-icon-section markup-card-section">
                                    <div className="markup-card-section-header">
                                        <label htmlFor="edit-icon">Type</label>
                                    </div>
                                    <ul className="icons">
                                        {
                                            this.state.icons.map((icon, key) => {
                                                return this.getIconLi(icon, key)
                                            })
                                        }
                                    </ul>
                                </div>
                                <div className="edit-color-section markup-card-section">
                                    <div className="markup-card-section-header">
                                        <label htmlFor="edit-color">Color</label>
                                    </div>
                                    <ul className="colors">
                                        {
                                            this.state.colors.map((colorItem, key) => {
                                                return this.getColorLi(colorItem, key)
                                            })
                                        }
                                    </ul>
                                </div>
                                <CustomInput
                                    id="input-notes"
                                    labelText="Notes"
                                    inputProps={{
                                        onChange: (e) => this.handleChange(e,'notes'),
                                        value: notes,
                                        name: "notes",
                                        type: "text",
                                        multiline: true,
                                        rows: 3,
                                    }}
                                    color="info"
                                    formControlProps={{
                                        fullWidth: true,
                                        className: classes.customFormControlClasses
                                    }}
                                />
                                <div className="photo-area-section markup-card-section">
                                    <div className="markup-card-section-header">
                                        <label>Photos</label>
                                        <div className="add-photo-button">
                                            <CustomFileInput
                                                id="add-photo-btn"
                                                onChange={(e) => this.handleFileChange(e,'photo')}
                                                endButton={{
                                                    buttonProps: {
                                                        fileButton: true,
                                                        link: true
                                                    },
                                                    text: "+ Add"
                                                }}
                                                inputProps={{
                                                    value: "",
                                                    placeholder: "Photo",
                                                    accept: ".jpeg, .jpg, .png"
                                                }}
                                                color="info"
                                                formControlProps={{
                                                    fullWidth: true,
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="photo-display">
                                        <div className="image-area">
                                            <div className="image-wrapper">
                                                {
                                                    photos.map((photo, key) => {
                                                        return this.getPhoto(photo, key)
                                                    })
                                                }
                                                {
                                                    uploading === true ?
                                                        <LoaderComponent align="center" color="info" />
                                                    :
                                                        <></>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="edit-actions">
                                <Button type="button" onClick={() => this.handleSubmit()} color="success" disabled={this.props.formButtonStatus === true ? false : true} fullWidth>Save</Button>
                            </div>
                        </form>
                    </div>
                </div>
                {
                    photoErrorModal ?
                        <PhotoErrorModal 
                            open={photoErrorModal} 
                            onClose={() => this.closePhotoErrorModal()} 
                            title="Your photo must be a .JPG or .PNG"
                            buttonText="Ok"
                        />
                    :
                        <></>
                }
            </div>
        );
    }
}

Waypoint.propTypes = {
  classes: PropTypes.object
};

export default withStyles(toolsStyle)(Waypoint);
